import toastr from 'toastr';

toastr.options = {
	"closeButton": true,
	"positionClass": "toast-bottom-right",
	"progressBar": true,
};

//Send it Jerry
export default toastr;
